export const adminSidebarSections = [
  {
    id: 'usuario',
    title: 'Usuario',
    icon: 'user',
    items: [
      { label: 'Cambiar Contraseña', href: '/cambiar-contrasena' },
    ],
  },
  {
    id: 'alumnos',
    title: 'Alumnos',
    icon: 'students',
    items: [
      { label: 'Alumnos', href: '/md-alumnos', module: 'WWAlumnos' },
      { label: 'Alumnos por Carrera', href: '/md-axc', module: 'WWAlumnosxCarrera' },
      { label: 'Estado Curricular', href: '/ecur', module: 'WWCertificados' },
    ],
  },
  {
    id: 'carreras',
    title: 'Carreras',
    icon: 'careers',
    items: [
      { label: 'Carreras', href: '/md-carreras', module: 'WWCarreras' },
      { label: 'Materias', href: '/md-mxc', module: 'WWMaterias' },
      { label: 'Correlatividades para Rendir', href: '/md-crendir', module: 'WWCorrelatividadesRendir' },
      { label: 'Correlatividades para Cursar', href: '/md-ccursar', module: 'WWCorrelatividadesCursada' },
    ],
  },
  {
    id: 'cursadas',
    title: 'Cursadas',
    icon: 'courses',
    items: [
      { label: 'Cursadas', href: '/md-cur', module: 'WWCursada' },
      { label: 'Inscripciones', href: '/md-ic', module: 'WWInscripcionCursada' },
      { label: 'Actas', href: '/md-acur', module: 'WWActasCursado' },
      { label: 'Historias Académicas', href: '/md-hic', module: 'HistoriaAcademicaCursada' },
    ],
  },
  {
    id: 'examenes',
    title: 'Exámenes',
    icon: 'exams',
    items: [
      { label: 'Mesas', href: '/md-mex', module: 'WWMesaExamen' },
      { label: 'Inscripciones', href: '/md-ie', module: 'WWInscripcionExamen' },
      { label: 'Actas', href: '/md-aex', module: 'WWActasExamen' },
      { label: 'Consulta Histórica de Actas', href: '/conactas', module: 'WWActasExamen' },
      { label: 'Historias Académicas', href: '/md-hex', module: 'HistoriaAcademicaExamen' },
    ],
  },
  {
    id: 'periodos',
    title: 'Períodos Académicos',
    icon: 'periods',
    items: [
      { label: 'Años Académicos', href: '/md-anios', module: 'WWAnioAcademico' },
      { label: 'Períodos de Exámenes', href: '/md-pex', module: 'WWPeriodoExamen' },
      { label: 'Períodos de Cursadas', href: '/md-pcr', module: 'WWPeriodoCursada' },
    ],
  },
  {
    id: 'auditoria',
    title: 'Auditoría',
    icon: 'audit',
    items: [
      { label: 'Consultar cambios del sistema', href: '/md-aud', module: 'WWAuditoria' },
    ],
  },
];

export const studentSidebarSections = [
  {
    id: 'usuario',
    title: 'Usuario',
    icon: 'user',
    items: [
      { label: 'Cambiar Contraseña', href: '/cambiar-contrasena' },
    ],
  },
  {
    id: 'cursadas',
    title: 'Cursadas',
    icon: 'courses',
    items: [
      { label: 'Inscripciones', href: '/md-ica', module: 'InscribirCursada' },
    ],
  },
];
